import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import Yonlendirme from "./components/Yonlendirme";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Yonlendirme />
  </React.StrictMode>
);